import type { SSOProviderOriginal } from '@nx/constants';

const BACK_CHANNEL_URI_PREFIXES = ['https://account-dev.neo4j.com', 'https://login.neo4j.com'];

function setToUnknownURI(uri: undefined | null | string): boolean {
  const isBackChannelUri = BACK_CHANNEL_URI_PREFIXES.some((prefix) => uri?.startsWith(prefix));
  return uri !== undefined && uri !== null && uri !== '' && !isBackChannelUri;
}

export function isFrontChannel(provider: SSOProviderOriginal): boolean {
  const { well_known_discovery_uri, token_endpoint, auth_endpoint, jwks_uri, issuer } = provider;

  // if the endpoints are set with unknown prefix, it's a front channel
  // back channels should have known Neo4j prefixes, or not set at all
  return (
    setToUnknownURI(well_known_discovery_uri) ||
    setToUnknownURI(token_endpoint) ||
    setToUnknownURI(auth_endpoint) ||
    setToUnknownURI(jwks_uri) ||
    setToUnknownURI(issuer)
  );
}
